const ApiError = require('@/lib/Api/ApiError');

/**
 * Represents an error during communication with the API (no connection, timeout, CORS issue, etc.),
 * rather than a problem that occurred on the server or was returned by the server.
 */
class NetworkApiError extends ApiError {
    constructor(message) {
        super(message || 'Network error', null, null, null);

        this.name = 'NetworkApiError';
    }
}

module.exports = NetworkApiError;
